import React from 'react';
import enhance from './enhance';
import styles from './styles.module.scss';
import DesignExpansion from '../DesignExpansion';

const MiniDesignSelection = ({
  close,
  closeWithoutSaving,
  options,
  templateId,
  designPackageForTemplate,
  selectedDesignOption,
  selectExpandedOption,
  expandedOption,
}) => (
  <div className={styles.designSelection}>
    <div className={styles.designSelectionInner}>
      <div className={styles.header}>
        <span className={styles.headerText}>Modify Design Selection</span>
        <button className={styles.button} onClick={close}>
          Save
        </button>
      </div>
      <div className={styles.main}>
        {options.map(option => (
          <DesignExpansion
            key={option}
            templateId={templateId}
            optionKey={option}
            designOption={designPackageForTemplate[option]}
            selectedDesignOption={selectedDesignOption}
            expandedOption={expandedOption}
            selectExpandedOption={selectExpandedOption}
          />
        ))}
      </div>
    </div>
    <div onClick={closeWithoutSaving} className={styles.outerArea} />
  </div>
);

export default enhance(MiniDesignSelection);
